import React from 'react';
import {Button} from "react-materialize";
import Dialog from 'react-toolbox/lib/dialog/Dialog';
import DatePicker from "react-toolbox/lib/date_picker/DatePicker";
import PropTypes from "prop-types";

class DocumentDateModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            selectedDate: new Date(),
        };

        this.handleToggle = this.handleToggle.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleToggle() {
        this.setState({
            open: !this.state.open
        })
    }

    handleSave() {
        this.setState({
            open: !this.state.open
        }, () => {
            this.props.generateHandler(this.state.selectedDate);
        })
    }

    handleChange(value) {
        this.setState({
            selectedDate: new Date(value.setHours(0,0,0,0))
        })
    }

    render() {
        const {open, selectedDate} = this.state;
        const {render} = this.props;

        return (
            <div>
                <Dialog
                    active={open}
                    onEscKeyDown={this.handleToggle}
                    onOverlayClick={this.handleToggle}
                    title="Define document's date">
                    <DatePicker
                        className="datepicker"
                        label="Document's date"
                        value={selectedDate ? selectedDate : ''}
                        inputFormat={(value) => `${value.getDate()}/${value.getMonth() + 1}/${value.getFullYear()}`}
                        onChange={this.handleChange}
                        autoOk={true}
                    />
                    <Button style={{float: 'right'}} onClick={this.handleSave}>Generate</Button>
                    <Button className="transparent" style={{float: 'right', color: 'black', marginRight: 20}}
                            onClick={this.handleToggle}>Cancel</Button>
                </Dialog>
                {render(this.handleToggle)}
            </div>
        )
    }
}

DocumentDateModal.propTypes = {
    render: PropTypes.func.isRequired,
    generateHandler: PropTypes.func.isRequired,
};

export default DocumentDateModal;


// WEBPACK FOOTER //
// ./src/components/fog/costInvoice/DocumentDateModal.js